import { Email } from './email';
import { Text } from './text';
import { Textarea } from './textarea';

export const fields = {
  email: Email,
  text: Text,
  textarea: Textarea,
};
